import { LoadingSpinnerIconTwoTone, Typography } from '@room-match/shared-ui-components';
import { useHistory } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
const { PASS_TEXT, WARNING_TEXT, PRIMARY_TEXT } = COLORS;
import { ItemContainer } from './DashboardItem.styles';
import { ls } from 'shared/utils/ls';

type Props = {
  icon: React.ReactElement;
  isLoading: boolean;
  label: string;
  count: number | string;
  link: string;
};

const DashboardItem: React.FC<Props> = ({ icon, isLoading = false, count = 0, label, link }) => {
  const history = useHistory();
  const { setLS } = ls();
  const handleClick = () => {
    if (label.includes('Self Tapes')) {
      setLS('isAuditionSTTab', true);
    } else {
      setLS('isAuditionSTTab', false);
    }

    history.push(link);
  };

  return (
    <ItemContainer onClick={handleClick}>
      {isLoading ? (
        <LoadingSpinnerIconTwoTone />
      ) : (
        <>
          <div style={{ marginTop: 30 }}>{icon}</div>
          <div style={{ flex: 1, textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
            <Typography fontWeight={500}>{label}</Typography>
            {count !== 0 && (
              <Typography
                fontSize={14}
                style={{
                  color:
                    label === 'Attended Auditions'
                      ? WARNING_TEXT
                      : label === 'Upcoming Auditions'
                        ? PASS_TEXT
                        : label === 'Check-In'
                          ? PRIMARY_TEXT
                          : PRIMARY_TEXT,
                }}
              >
                {`${count} Pending`}
              </Typography>
            )}
          </div>
        </>
      )}
    </ItemContainer>
  );
};

export default DashboardItem;
